import { z } from 'zod';
import { entityIdSchema } from '@kop/contracts';
export const incidentLedgerScopeSchema = z.discriminatedUnion('kind', [
    z
        .object({
        kind: z.literal('site'),
        tenantId: z.literal('kop'),
        siteId: entityIdSchema,
    })
        .strict(),
    z
        .object({
        kind: z.literal('contractor'),
        tenantId: z.literal('kop'),
        siteId: entityIdSchema,
        contractorId: entityIdSchema,
    })
        .strict(),
]);
export const incidentLedgerCursorSchema = z
    .object({
    updatedAt: z.string().datetime(),
    recordId: entityIdSchema,
})
    .strict();
export const incidentLedgerListRequestSchema = z
    .object({
    scope: incidentLedgerScopeSchema,
    pageSize: z.number().int().min(1).max(50).default(30),
    cursor: incidentLedgerCursorSchema.nullable().default(null),
})
    .strict();
export const incidentLedgerDetailRequestSchema = z
    .object({
    scope: incidentLedgerScopeSchema,
    recordId: entityIdSchema,
})
    .strict();
